import { AuthButton } from '@/web-app/views/users/components/auth-button'
import { CsrfInput } from '@/web-app/views/users/components/csrf-input'
import { addTimezoneAndAnalyticsTo } from '@/web-app/views/users/utils/add-timezone-and-analytics'
import microsoftLogo from '@/assets/microsoft.png'

interface MicrosoftAuthButtonProps {
  authUrl?: string
  label: string
  fromMicrosoft?: boolean
  showCalendarNotFoundError?: boolean
  showMissingScopesError?: boolean
  showOopsError?: boolean
  showUnavailableCalendarError?: boolean
  showWorkEmailRequiredError?: boolean
}

export function MicrosoftAuthButton({
  authUrl,
  label,
  fromMicrosoft = false,
  showCalendarNotFoundError = false,
  showMissingScopesError = false,
  showOopsError = false,
  showUnavailableCalendarError = false,
  showWorkEmailRequiredError = false,
}: MicrosoftAuthButtonProps) {
  if (!authUrl) return null

  return (
    <form id='microsoft_form' method='post' action={addTimezoneAndAnalyticsTo(authUrl)}>
      <CsrfInput />
      <AuthButton
        image={microsoftLogo}
        label={label}
        available
        missingScopes={fromMicrosoft && showMissingScopesError}
        oopsError={fromMicrosoft && showOopsError}
        unavailableCalendar={fromMicrosoft && showUnavailableCalendarError}
        workEmailRequired={fromMicrosoft && showWorkEmailRequiredError}
        calendarNotFound={fromMicrosoft && showCalendarNotFoundError}
      />
    </form>
  )
}
